var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/35636a2ff19997a96ca2d0d1b52a6aea.js').default;export default
        Object.assign({}, scope_0 )
    